import React from "react"
import DocumentFormPresenterGeneral from "./tabs/DocumentFormPresenterGeneral"
import DocumentFormPresenterFormFields from "./tabs/DocumentFormPresenterFormFields"
import DocumentFormPresenterRates from "./tabs/DocumentFormPresenterRates"
import DocumentFormPresenterProducts from "./tabs/DocumentFormPresenterProducts"
import DocumentFormPresenterAnswers from "./tabs/DocumentFormPresenterAnswers"
import DocumentFormPresenterFormInformation from "./tabs/DocumentFormPresenterFormInformation"


class DocumentFormPresenterWorkspace extends React.Component {
  
  constructor(props) {
    super(props)
  }

  render() {
    if(this.props.answer_view == true) {

      return (
        <div className="tab-content">
          <DocumentFormPresenterAnswers {...this.props} />
          <DocumentFormPresenterFormInformation {...this.props} />
        </div>
      )
    } else {

      return (
        <div className="tab-content">
          <DocumentFormPresenterGeneral {...this.props} />
          <DocumentFormPresenterFormFields {...this.props} />
          <DocumentFormPresenterRates {...this.props} />
          <DocumentFormPresenterProducts {...this.props} />
        </div>
      )
    }
  }

}

export default DocumentFormPresenterWorkspace